const ProductDescriptionDisplay = ({ description }) => (
  <div className="mt-4">
    <label className="block text-sm font-medium font-inter text-gray-600 mb-2">
      Product Description
    </label>
    <textarea
      rows="4"
      value={description}
      readOnly
      className="w-full px-4 py-3 border-b border-gray-300 rounded-md bg-neutral-200-100 text-gray-600 resize-none cursor-not-allowed"
    />
  </div>
)

export default ProductDescriptionDisplay
